import type {CmLogger} from "@cm/log"
import {ImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const imageOpNode = <Ctor extends new (...args: any[]) => ImageOpNode>(
    node: InstanceType<Ctor> | undefined,
    ctor: Ctor,
    parameters: ConstructorParameters<Ctor>[0],
    postCtor?: (instance: InstanceType<Ctor>) => void,
): InstanceType<Ctor> => {
    if (node === undefined) {
        imageOpNodeLogger?.debug(`ImageOpNodeBag: creating new node ${ctor.name}`)
        node = new ctor(parameters) as InstanceType<Ctor> // TODO why is this type assertion needed?
        postCtor?.(node)
    } else {
        node.setParameters(parameters)
    }
    return node
}

export let imageOpNodeLogger: CmLogger | undefined
